import { AxiosError } from 'axios';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Navigate, RouteProps, useLocation } from 'react-router-dom';

import { backendErrorNotification } from '../../components/Notification';
import HttpStatus from '../../enums/httpStatus';
import { UrlPaths } from '../../enums/urlPaths.enum';
import { signinByTokenReq } from '../../services/requests';
import { signInSuccess } from '../../store/modules/auth/actions';
import { AuthResponseData } from '../../types/auth';

type PrivateRouteProps = RouteProps;

const ExternalAuthentication: React.FC<PrivateRouteProps> = () => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);
  const [urlPath, setUrlPath] = useState<UrlPaths | string>(UrlPaths.NOT_FOUND);

  const query = new URLSearchParams(useLocation().search);
  const token = query.get('token');
  const page = query.get('page');

  if (!token) {
    return <Navigate to={UrlPaths.NOT_AUTHORIZED} />;
  }

  if (!page) {
    return <Navigate to={UrlPaths.NOT_FOUND} />;
  }

  const loginByTokenRequest = async () => {
    setIsLoading(true);
    try {
      const response = await signinByTokenReq(token);

      if ('response' in response) {
        const { status } = response.response;

        if (status !== HttpStatus.OK) {
          throw status;
        }

        const loginDataSuccessful: AuthResponseData = response.response.data.data;

        dispatch(signInSuccess(loginDataSuccessful));

        setUrlPath(`/${page}`);
        setIsLoading(false);
      } else {
        setUrlPath(UrlPaths.NOT_AUTHORIZED);
        setIsLoading(false);
      }
    } catch (err) {
      backendErrorNotification(err as AxiosError<any, any>);

      setUrlPath(UrlPaths.NOT_AUTHORIZED);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loginByTokenRequest();
  }, []);

  return isLoading ? <p>loading...</p> : <Navigate to={urlPath} />;
};

export default ExternalAuthentication;
